<template>
  <div style="text-align: left">
    <el-form :inline="true" :model="formInline" class="demo-form-inline"  @keydown.native.enter="$emit('search', formInline)">
      <!-- <el-form-item label="批次包编号">
        <el-input maxlength='450' v-model="formInline.pkgCode" placeholder="请输入批次包编号"></el-input>
      </el-form-item> -->
      <el-form-item label="商品SKU">
        <el-input maxlength='450' v-model="formInline.shopProductSku" placeholder="请输入商品SKU"></el-input>
      </el-form-item>
      <el-form-item label="店铺名">
        <el-input maxlength='450' v-model="formInline.customerShopName" placeholder="请输入店铺名"></el-input>
      </el-form-item>
      <el-form-item label="订单来源">
        <el-select v-model="formInline.systemSource" placeholder="来源">
          <el-option label="全部" :value="undefined"></el-option>
          <el-option label="D2C" :value="1"></el-option>
          <el-option label="B2B" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="所在区域">
        <el-select v-model="formInline.kuQu" placeholder="所在区域" @change="$emit('search', formInline)">
          <el-option label="全部" :value="''"></el-option>
          <el-option label="成品区" :value="1"></el-option>
          <el-option label="次品区" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="签收时间">
        <el-date-picker
            v-model="formInline.date"
            @change="dateChange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-radio-group v-model="formInline.day" @change="$emit('search', formInline)">
          <el-radio :label="1">今日</el-radio>
          <el-radio :label="2">近2天</el-radio>
          <el-radio :label="3">近3天</el-radio>
          <el-radio :label="5">近5天</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item>
        <el-button style="margin-left: 30px" type="primary" @click="$emit('search', formInline)">搜索</el-button>
        <el-button style="margin-left: 10px" @click="rest">重置</el-button>
        <el-button @click="print" type="primary">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "From",
  data() {
    return {
      formInline: {}
    }
  },
  mounted() {
    this.$emit('search', this.formInline)
  },
  methods: {
    dateChange: function (date) {
      // console.log(val)
      if (!date) {
        this.formInline.createStartTime = null
        this.formInline.createEndTime = null
        return
      }
      this.formInline.createStartTime = date[0].getTime();
      this.formInline.createEndTime = date[1].getTime();
      this.$emit('search', this.formInline)
    },
    rest: function () {
      this.formInline = {}
      this.$emit('search', this.formInline)
    },
    print(){
      this.$emit('print')
    }
  }
}
</script>

<style scoped>
</style>